// Module-level store for the currently signed-in MSAL account.
//
// The axios request interceptor needs the account to call
// acquireTokenSilent, but it isn't a React component and can't use the
// useMsal hook. MsalAuthWrapper writes here once the account is
// resolved; everything that wants the active account reads from here.
let activeAccount = null;

export const setMsalAccount = (account) => {
  activeAccount = account;
};

export const getMsalAccount = () => activeAccount;
